import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { PartialFlowStep } from "../steps";

export function replaceNextElement(
  oldNext: string,
  newNext: string | undefined,
  steps: PartialFlowStep[],
) {
  if (oldNext === newNext) {
    return;
  }
  for (let i = 0; i < steps.length; i++) {
    const step = steps[i];

    // For RULE_CONDITIONS, create a new object to handle immutability
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if (step.type === StepType.RULE_CONDITIONS) {
      let updated = false;
      let updatedStep = step;

      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (step.nextTrueId === oldNext) {
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        updatedStep = { ...updatedStep, nextTrueId: newNext };
        updated = true;
      }
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (step.nextFalseId === oldNext) {
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        updatedStep = { ...updatedStep, nextFalseId: newNext };
        updated = true;
      }

      if (updated) {
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        steps[i] = updatedStep;
      }
      continue;
    }

    // For other step types, use direct mutation
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("nextId" in step && step.nextId === oldNext) {
      step.nextId = newNext;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("nextTrueId" in step && step.nextTrueId === oldNext) {
      step.nextTrueId = newNext;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("nextFalseId" in step && step.nextFalseId === oldNext) {
      step.nextFalseId = newNext;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("matchingNextId" in step && step.matchingNextId === oldNext) {
      step.matchingNextId = newNext;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("nonMatchingNextId" in step && step.nonMatchingNextId === oldNext) {
      step.nonMatchingNextId = newNext;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("acceptNextId" in step && step.acceptNextId === oldNext) {
      step.acceptNextId = newNext;
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("declineNextId" in step && step.declineNextId === oldNext) {
      step.declineNextId = newNext;
    }

    // Handle AB test variants
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("variants" in step && step.variants) {
      step.variants = step.variants.map((variant) => {
        if (variant.nextId === oldNext) {
          return { ...variant, nextId: newNext };
        }
        return variant;
      });
    }

    // Handle RCO split treatments
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("treatments" in step && step.treatments) {
      step.treatments = step.treatments.map((treatment) => {
        if (treatment.nextId === oldNext) {
          return { ...treatment, nextId: newNext };
        }
        return treatment;
      });
    }

    // Handle N-ary segment edges
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if ("edges" in step && step.edges) {
      step.edges = step.edges.map((edge) => {
        if (edge.nextId === oldNext) {
          return { ...edge, nextId: newNext };
        }
        return edge;
      });
    }
  }
}
